import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
// import 'rxjs/add/observable/throw';
// import * as Rx from 'rxjs';

import {StoreService} from '../store/store.service';

declare const moment: any;

@Injectable()
export class MockApiService {

    private mockDataDirPath: string;

    private static extractData(res: Response) {
        let body = res.json();
        return body || [];
    }

    private static handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead

        return Observable.throw(errMsg);
    }

    constructor(private store: StoreService,
                private http: Http) {
        this.mockDataDirPath = 'assets/data/';
    }

    get(uri) {
        return this.http.get(uri).map((data) => {
            return MockApiService.extractData(data);
        }).catch(error => MockApiService.handleError(error));
    }

    getMockData(jsonFileName) {
        const mockDataUri = this.mockDataDirPath + jsonFileName;
        return this.get(mockDataUri);
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/mock-api/mock-api.service.ts